import {
  GET_SALES_BOOK,
  GET_SALES_BOOK_SUCCESS,
  GET_SALES_BOOK_FAIL,
  DELETE_SALES_BOOK,
  DELETE_SALES_BOOK_SUCCESS,
  DELETE_SALES_BOOK_FAIL,
  UPDATE_SALES_BOOK,
  UPDATE_SALES_BOOK_SUCCESS,
  UPDATE_SALES_BOOK_FAIL,
  ADD_NEW_SALES_BOOK,
  ADD_SALES_BOOK_SUCCESS,
  ADD_SALES_BOOK_FAIL,
  SALES_BOOK_LOADING,
  SALES_BOOK_RESET,
} from "./actionType";

export const resetSalesBookState = (actionType) => ({
  type: SALES_BOOK_RESET,
  payload: { actionType },
});

export const getSalesBookSuccess = (actionType, data) => ({
  type: GET_SALES_BOOK_SUCCESS,
  payload: { actionType, data },
});

export const getSalesBookFail = (actionType, error) => ({
  type: GET_SALES_BOOK_FAIL,
  payload: { actionType, error },
});

export const getSalesBook = data => ({
  type: GET_SALES_BOOK,
  payload: data,
});

export const getSalesBookLoading = () => ({
  type: SALES_BOOK_LOADING
});

export const deleteSalesBook = data => ({
  type: DELETE_SALES_BOOK,
  payload: data,
});

export const deleteSalesBookSuccess = data => ({
  type: DELETE_SALES_BOOK_SUCCESS,
  payload: data,
});

export const deleteSalesBookFail = error => ({
  type: DELETE_SALES_BOOK_FAIL,
  payload: error,
});

export const updateSalesBook = data => ({
  type: UPDATE_SALES_BOOK,
  payload: data,
});

export const updateSalesBookFail = error => ({
  type: UPDATE_SALES_BOOK_FAIL,
  payload: error,
});

export const updateSalesBookSuccess = data => ({
  type: UPDATE_SALES_BOOK_SUCCESS,
  payload: data,
});

export const addNewSalesBook = data => ({
  type: ADD_NEW_SALES_BOOK,
  payload: data,
});

export const addSalesBookSuccess = data => ({
  type: ADD_SALES_BOOK_SUCCESS,
  payload: data,
});

export const addSalesBookFail = error => ({
  type: ADD_SALES_BOOK_FAIL,
  payload: error,
});